import { Redemptions } from '@mindfulchefuk/features/Subscription/interfaces'

export const selectWinBack = (redemptions: Redemptions) => {
  const latestRedemption = redemptions[0]

  return latestRedemption?.type === 'Winback' ? [latestRedemption] : []
}
